<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <h3 class="text-primary text-uppercase">Dati Societ&agrave;</h3>
            </b-col>
        </b-row>
        <b-row class="align-items-end">
            <b-col cols="12" md="10" class="mb-3">
                <inter-input
                        label="Nome"
                        v-model="user.data.society"
                        icon="group"
                        :error="errors.society">
                </inter-input>
            </b-col>
            <b-col cols="12" md="auto" class="ml-auto mb-3 ">
                <swatches v-model="user.color"
                          colors="text-advanced"
                          popover-to="left"
                          :trigger-style="{ width: '60px', height: '60px' }"
                >
                </swatches>
            </b-col>
        </b-row>
        <b-row class="align-items-end">
            <b-col cols="12" md="7" class="mb-3">
                <inter-input
                        label="Email"
                        v-model="user.data.society_email"
                        icon="mail"
                        :error="errors.society_email">
                </inter-input>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <inter-input
                        label="Telefono"
                        v-model="user.data.society_phone"
                        icon="phone-call"
                        :error="errors.society_phone">
                </inter-input>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12">
                <h3 class="text-primary text-uppercase">Dati Referente</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Nome"
                        v-model="user.name"
                        icon="group"
                        :error="errors.name">
                </inter-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Cognome"
                        v-model="user.surname"
                        icon="group"
                        :error="errors.surname">
                </inter-input>
            </b-col>
        </b-row>
        <b-row class="align-items-end">
            <b-col cols="12" md="7" class="mb-3">
                <inter-input
                        label="Email"
                        v-model="user.email"
                        icon="mail"
                        :error="errors.email">
                </inter-input>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <inter-input
                        label="Telefono"
                        v-model="user.data.phone"
                        icon="phone-call"
                        :error="errors.phone">
                </inter-input>
            </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-center">
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                        label="Stato"
                        placeholder="Stato"
                        v-model="user.status"
                        :option-selected="user.status"
                        :options="getStatusOptions"
                ></inter-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <inter-rich-text @onEditorUpdate="updateLocalText" v-if="user.status === 'rejected'"></inter-rich-text>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterInput from "../../../components/form/inter-input/InterInput";
    import User from "@/models/User";
    import Swatches from "vue-swatches/src/Swatches";
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import InterRichText from "../../../components/inter-rich-text/InterRichText";
    import _ from "lodash";

    export default {
        name: "AdminSocietyForm",
        components: {InterSelect, Swatches, InterInput, InterRichText},
        data() {
            return {
                errors: {},
            }
        },
        props: {
            user: {
                type: Object,
                default: () => Object.assign({}, User)
            },
            text: {
                type: String,
                default: null
            },
        },
        computed: {
            getStatusOptions() {
                if (this.user.status === 'pending') {
                    return [
                    { name: 'APPROVATO', value: 'approved' },
                    { name: 'RIFIUTATO', value: 'rejected' }
                    ];
                } else {
                    return [
                    { name: 'IN ATTESA', value: 'pending' },
                    { name: 'APPROVATO', value: 'approved' }
                    ];
                }
            },
        },
        methods: {
            updateLocalText(value) {
                this.$emit("localTextUpdated", value);
            },
            validate: function () {
                this.errors = {};
                if (this.user.name === '') {
                    this.errors.name = true;
                }
                if (this.user.surname === '') {
                    this.errors.surname = true;
                }

                if (this.user.email === '') {
                    this.errors.email = true;
                }

                if (_.isEmpty(this.errors)) {
                    return true;
                } else {
                    this.$bvToast.toast('Mi manca qualche dato', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
